import React from "react";

// react-bootstrap components
import { Card, Container, Row, Col, Table } from "react-bootstrap";

const toolsAndTech = [
  { name: "ftp 접속 도구", level: "80%", tech: "파일질라, 알드라이브" },
  { name: "웹에디터", level: "95%", tech: "서브라임텍스트, editplus, note++" },
  { name: "ssh 접속도구", level: "50%", tech: "putty" },
  { name: "ssh 접속도구", level: "70%", tech: "dbeaver, oracle orange" },
  {
    name: "개발 프레임워크",
    level: "80%",
    tech: "이클립스(전자정부프레임워크), 인텔리제이, spring 3, spring 4(spring boot), VS-code",
  },
];

const skills = [
  { name: "웹표준(html5&css3&jquery)", level: "95%", tech: "" },
  { name: "javascript", level: "95%", tech: "ajax, API 라이브러리 연동" },
  {
    name: "어도비 포토샵",
    level: "20%",
    tech: "이미지 자르기, 색도 조정, 색상 조정, 투명도 조정, 필터",
  },
  { name: "어도비 일러스트레이터", level: "20%", tech: "로고 간단하게 제작" },
  { name: "react", level: "50%", tech: "next.js" },
  { name: "vue", level: "75%", tech: "AG-grid.js" },
  { name: "반응형 웹", level: "95%", tech: "부트스트랩, 미디어쿼리" },
  { name: "java", level: "70%", tech: "jstl, mybatis" },
  {
    name: "리눅스",
    level: "70%",
    tech:
      "vi 명령어, tail 로그 실시간 출력, 압축 해제, 압축, npm/yum 패키지설치 명령어, sudo 설정, 권한 설정, jdk 환경변수 설정",
  },
  {
    name: "아파치 & 톰캣",
    level: "50%",
    tech: "config.xml 파일 설정, server.xml 파일 설정, 서버 종료 & 서버 시작",
  },
  {
    name: "RDBMS(oracle, mysql, tibero, mariadb, mssql)",
    level: "85%",
    tech: "join, union, subquery, alias, 시퀀스, CRUD, 프로시저, 트리거",
  },
  { name: "node.js", level: "70%", tech: "express.js" },
];

const itKnowledge = [
  { name: "디자인 패턴", level: "80%", tech: "model 1, JPA, MVC, node.js + js뷰(react, vue, ext)" },
  { name: "형상관리", level: "95%", tech: "svn, 소스트리, 젠킨스, git" },
  { name: "개발 지식", level: "50%", tech: "클래스명 카멜 표준법, 소스 정리" },
];

function SkillTable({ title, headers, rows }) {
  return (
    <Col md="12">
      <Card>
        <Card.Header>
          <Card.Title as="h3" className="text-center w-100">
            {title}
          </Card.Title>
        </Card.Header>
        <Card.Body className="table-full-width table-responsive px-0">
          <Table className="table-hover table-striped info-table skill-table">
            <thead>
              <tr>
                <th className="border-0">{headers[0]}</th>
                <th className="border-0">{headers[1]}</th>
                <th className="border-0">{headers[2]}</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, idx) => (
                <tr key={idx}>
                  <td data-label={headers[0]}>{row.name}</td>
                  <td data-label={headers[1]}>{row.level}</td>
                  <td data-label={headers[2]}>{row.tech}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Card.Body>
      </Card>
    </Col>
  );
}

function Icons() {
  return (
    <>
      <Container fluid>
        <Row>
          <SkillTable
            title="도구 및 기술"
            headers={["도구명", "숙련도", "확장 기술"]}
            rows={toolsAndTech}
          />
          <SkillTable
            title="숙련도 & 보유 스킬"
            headers={["기술명", "숙련도", "확장 기술"]}
            rows={skills}
          />
          <SkillTable
            title="IT 지식"
            headers={["개념명", "숙련도", "확장 기술"]}
            rows={itKnowledge}
          />
        </Row>
      </Container>
    </>
  );
}

export default Icons;
